module.exports = __webpack_public_path__ + "static/media/max-funding-icon.38d77833.svg";